import css from './LocationSelector.module.scss'
import { useDispatch, useSelector } from 'react-redux'
import { useEffect, useState } from 'react'
import { toast } from 'react-toastify'
import ImagePlaceholder from '../atoms/ImagePlaceholder'
import { getCounts, getLocations, getPaymentLink } from 'src/slices/info'
import { setBranch } from 'src/slices/auth'
import { useLocation, useNavigate } from 'react-router-dom'

import Select, { components } from 'react-select'
import Pill from '../atoms/Pill'
import colors from 'src/styles/jscolors.module.scss'
import {
	addLocation,
	clearState,
	getBusinessInfoSignup,
	setStep,
	setToken,
} from 'src/slices/signup'
import { handleStatus } from 'src/slices/utils'
import Button from '../atoms/Button'

export default function LocationSelector() {
	const dispatch = useDispatch()
	const navigate = useNavigate()
	const locationHook = useLocation()

	const { locations, status } = useSelector(state => state.info)
	const { currBranch, token, refreshToken } = useSelector(state => state.auth)
	const { status: signupStatus, user } = useSelector(state => state.signup)
	const [location, setLocation] = useState()

	useEffect(() => {
		dispatch(getLocations())
	}, [])

	useEffect(() => {
		dispatch(getCounts())
		dispatch(getPaymentLink())
	}, [currBranch])
	useEffect(() => {
		if (locations.length > 0) {
			const defaultLoc =
				locations.find(location => location._id == currBranch) || locations[0]
			setLocation({
				label: defaultLoc.businessName,
				value: { id: defaultLoc._id, logo: defaultLoc.businessLogo },
			})
		}
	}, [locations])

	useEffect(() => {
		if (locationHook.pathname != '/profile') {
			handleStatus(signupStatus.addLocation, () => dispatch(clearState()), {
				isSuccess: {
					callback: () => {
						dispatch(setToken({ token, refreshToken, data: user.id }))
						dispatch(getBusinessInfoSignup())
					},
				},
			})
		}
	}, [signupStatus])

	const handleLocation = selectedOption => {
		if (selectedOption.profileCompleted) {
			toast.info('Switching location...')

			setLocation(selectedOption)
			dispatch(setBranch(selectedOption.value.id))

			window.location.reload()
		} else {
			dispatch(setToken({ token, refreshToken, data: selectedOption.value.id }))
			dispatch(getBusinessInfoSignup())
		}
	}
	useEffect(() => {
		handleStatus(signupStatus.getBusinessInfoSignup, () => dispatch(clearState()), {
			isSuccess: {
				callback: () => {
					dispatch(setStep(1))
					navigate('/signup')
				},
				toast: locations.some(location => location._id == user.id),
			},
		})
	}, [signupStatus])

	const { Option } = components
	const IconOption = props => (
		<Option {...props}>
			{/* <i className='fas fa-circle-exclamation'></i> */}
			{/* <div style={{ display: 'inline-flex' }}> */}
			<div>{props.data.label}</div>
			<ImagePlaceholder
				src={props.data.value.logo}
				size='25px'
				iconName='store'
				className={css['store-logo']}
			/>
			{/* </div> */}

			{!props.data.profileCompleted && (
				<Pill
					label='Profile Incomplete'
					color='red'
					variant='secondary'
				/>
			)}
		</Option>
	)
	const colorStyles = {
		option: (styles, { data }) => {
			return {
				...styles,
				backgroundColor: data.color,
			}
		},
	}

	// custom no options message
	const NoOptionsMessage = props => {
		return (
			<components.NoOptionsMessage {...props}>
				<span className={css['no-branch-message']}>No other branches found</span>
			</components.NoOptionsMessage>
		)
	}

	// custom menu dropdown with add button
	const SelectMenuButton = props => {
		return (
			<components.MenuList {...props}>
				{props.children}
				<Button
					action={() => dispatch(addLocation())}
					label='Add Store Branch'
					color='blue'
					iconLeft='fad fa-plus'
					variant='secondary'
					style={{ width: 'max-content', margin: 'auto' }}
				/>
			</components.MenuList>
		)
	}

	return status.getLocations.isLoading ? (
		<div
			style={{ minHeight: '72px' }}
			className={css.box}>
			<i className='fad fa-spinner fa-spin' />
		</div>
	) : (
		status.getLocations.isSuccess && (
			<div className={css['box']}>
				{/* {location?.value.businessLogo && ( */}

				{location?.value && (
					<ImagePlaceholder
						src={location?.value?.logo}
						size='40px'
						alt='store logo'
						iconName='fad fa-store'
						style={{
							flexGrow: '0',
							background: '#d4d4d8',
							borderRadius: '4px',
						}}
					/>
				)}

				<Select
					className={css['select']}
					options={locations
						?.filter(location => location._id != currBranch)
						.map((location, index) => ({
							label: location.businessName,
							value: {
								id: location._id,
								logo: location.businessLogo,
							},
							profileCompleted: location.profileCompleted,
							color: index % 2 == 1 ? colors['gray-100'] : 'white',
						}))}
					value={location}
					onChange={handleLocation}
					isSearchable={false}
					// menuIsOpen
					// isDisabled={locations.length <= 1}
					components={{
						NoOptionsMessage,
						Option: IconOption,
						MenuList: SelectMenuButton,
					}}
					styles={colorStyles}
				/>
			</div>
		)
	)
}
